/**
 * API base URL for Email Ajent public companion API.
 * Override with `REACT_APP_API_BASE_URL` for local/staging.
 */
export const API_BASE_URL: string =
  process.env.REACT_APP_API_BASE_URL ?? "https://api.emailajent.com";
